module.exports = __webpack_public_path__ + "static/img/jiaying-success.2af77620.png";